import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Sun, Battery, Cpu, Wrench, House, ArrowRight } from "lucide-react";
import SectionLabel from "@/components/layout/SectionLabel";

const ITEMS = [
  { icon: Sun, t: "Solar PV", b: "Generate your own clean electricity." },
  { icon: Battery, t: "ESS batteries", b: "Store solar for evenings and outages." },
  { icon: Cpu, t: "Smart hot water control", b: "Coordinate hot water with solar generation." },
  { icon: Wrench, t: "Monoblock heating", b: "Efficient electric home heating." },
  { icon: House, t: "Whole-home electrification", b: "A full pathway to zero carbon at home." },
];

export default function SolarBattery() {
  return (
    <div className="bg-white">
      <section className="border-b border-[#E2E8F0]">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 py-20">
          <SectionLabel>Solar + Battery — coming next</SectionLabel>
          <h1 className="font-heading mt-4 text-4xl sm:text-6xl font-bold tracking-tight text-[#0B132B]">
            Start with Hot Water. Prepare for Solar and Battery.
          </h1>
          <p className="mt-5 text-lg text-[#475569] max-w-2xl">
            Hot water is only the beginning. AeroMax Energy's long-term vision is to help New Zealand homes move toward energy independence through solar PV, home battery storage and smart electrification.
          </p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6 sm:px-8 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {ITEMS.map((it, i) => (
            <Card key={i} className="rounded-2xl p-7 border-[#E2E8F0] bg-white">
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-[#2563EB]/10 text-[#2563EB] mb-4">
                <it.icon className="h-5 w-5" />
              </span>
              <p className="font-heading text-xl font-semibold text-[#0B132B]">{it.t}</p>
              <p className="text-sm text-[#475569] mt-1">{it.b}</p>
            </Card>
          ))}
        </div>
        <div className="text-center mt-12">
          <Link to="/aeromax-270l" data-testid="solar-cta" className="inline-flex items-center gap-2 rounded-full bg-[#10B981] hover:bg-[#059669] text-white px-7 py-4 font-semibold">
            Register Interest in Future Energy Packages <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
